var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTestEnv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 206 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #0e0f0c;\n      }\n\n      .cls-3 {\n        fill: #f72032;\n      }\n\n      .cls-4 {\n        fill: #f2faf5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -38,
    y1: 165.1,
    x2: -38.5,
    y2: 164.5,
    gradientTransform: "translate(1558.3 6935.2) scale(40 -42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f72032"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74960",
    "data-name": "Group 74960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73219",
    "data-name": "Group 73219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    className: "cls-4",
    d: "M.8,22.6v-11.7c0-1.4.2-2.7.8-3.9,1.2-2.7,4-4.5,7-4.4,6,0,12,0,18.1,0,1.8,0,3.5.7,4.7,2,2.3,2.3,4.6,4.6,6.9,6.8,1.3,1.3,2.2,3,2.4,4.8,0,.3,0,.5,0,.8,0,6.8,0,13.5,0,20.3.1,2.8-1.5,5.4-4,6.6-.9.5-2,.7-3.1.7H10.6c-4.5,0-8.4-3-9.5-7.3-.2-.7-.3-1.4-.3-2.2,0-4.2,0-8.3,0-12.4h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73089",
    "data-name": "Group 73089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    className: "cls-2",
    d: "M63.1,3.6c7.1,0,11.4,4.3,11.4,11.8s-4.2,12-11.4,12h-9.2V3.6h9.2ZM58.8,23.3h3.6c4.4,0,6.8-2.7,6.8-7.9s-2.5-7.7-6.8-7.7h-3.6v15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    className: "cls-2",
    d: "M76.6,18.3c0-5.8,3.5-9.4,9-9.4s9,3.6,9,9.4-3.5,9.4-9,9.4-9-3.5-9-9.4ZM89.6,18.3c0-3.6-1.5-5.7-4.1-5.7s-4.1,2.1-4.1,5.7,1.5,5.7,4.1,5.7,4.1-2.1,4.1-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    className: "cls-2",
    d: "M109.1,15.9c-.2-1.9-1.8-3.3-3.7-3.2-2.5,0-4.1,2.1-4.1,5.6s1.6,5.6,4.1,5.6c1.9.2,3.5-1.2,3.7-3.1h4.5c-.3,4.2-3.5,6.9-8.2,6.9s-8.9-3.6-8.9-9.4,3.5-9.4,8.9-9.4,8,3,8.2,7h-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    className: "cls-2",
    d: "M132.6,27.4h-4.6v-3.3h0c-.8,2.3-3,3.7-5.5,3.6-3.9,0-6.5-2.6-6.5-6.8v-11.6h4.8v10.7c0,2.5,1.2,3.8,3.5,3.8s3.6-1.6,3.6-4.1v-10.4h4.8v18.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    className: "cls-2",
    d: "M153.9,18.3c0,5.8-2.8,9.3-7.4,9.3-2.4.1-4.6-1.2-5.7-3.3h0v9h-4.8V9.3h4.7v3.1h0c1.1-2.1,3.3-3.4,5.7-3.3,4.6,0,7.5,3.5,7.5,9.3ZM148.9,18.3c0-3.3-1.6-5.4-4.1-5.4s-4.1,2.2-4.1,5.4,1.6,5.4,4.1,5.4c2.5,0,4.1-2.1,4.1-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    className: "cls-2",
    d: "M155.7,22.2c0-3.3,2.5-5.2,7.2-5.5l4.5-.3v-1.2c0-1.7-1.2-2.7-3.2-2.7-1.5-.1-2.8.8-3.2,2.2h-4.4c.1-3.5,3.3-5.9,7.8-5.9s7.7,2.4,7.7,6v12.5h-4.6v-2.8h0c-1.2,1.9-3.3,3.1-5.6,3-3.5,0-6.2-2.2-6.2-5.4ZM167.4,20.8v-1.4l-3.8.3c-2,.1-3.1.9-3.1,2.3s1.1,2.2,2.9,2.2c2.2,0,4-1.4,4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    className: "cls-2",
    d: "M181.5,5.2v4.1h3.4v3.6h-3.4v8.8c0,1.4.7,2.1,2.2,2.1.4,0,.8,0,1.2,0v3.6c-.8.1-1.5.2-2.3.2-4.2,0-5.9-1.4-5.9-5v-9.6h-2.5v-3.6h2.5v-4.1h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    className: "cls-2",
    d: "M187.7,2.5h4.7v10.1h0c1-2.3,3.3-3.7,5.7-3.5,4,0,6.3,2.6,6.3,6.8v11.6h-4.8v-10.6c0-2.4-1.2-3.8-3.5-3.8s-3.8,1.6-3.8,4.1v10.3h-4.8V2.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    className: "cls-1",
    d: "M.8,22.6v-11.7c0-1.4.2-2.7.8-3.9,1.2-2.7,4-4.5,7-4.4,6,0,12,0,18.1,0,1.8,0,3.5.7,4.7,2,2.3,2.3,4.6,4.6,6.9,6.8,1.3,1.3,2.2,3,2.4,4.8,0,.3,0,.5,0,.8,0,6.8,0,13.5,0,20.3.1,2.8-1.5,5.4-4,6.6-.9.5-2,.7-3.1.7H10.6c-4.5,0-8.4-3-9.5-7.3-.2-.7-.3-1.4-.3-2.2,0-4.2,0-8.3,0-12.4h0ZM36.9,20.5h0s0,0,0,0c-2.3,5.1-6.4,7.7-11.8,8.3-1.8.2-3.7,0-5.6.1-2.1,0-4.1.6-5.8,1.8-1.8,1.2-2.8,3.2-2.8,5.4v4.4h22.8c1.7,0,3.1-1.2,3.2-2.9,0-.3,0-.6,0-.9,0-4.9,0-9.9,0-14.9v-1.4h0ZM4.7,22.2c.1-.1.2-.3.3-.4,0-.1.2-.2.3-.3,2.5-2.3,5.7-3.7,9.1-4.1,1.6-.1,3.3-.2,4.9-.2.8,0,1.6,0,2.4,0,2.2-.3,4.2-1.5,5.4-3.5.1-.2.1-.4,0-.6-.2-.6-.4-1.2-.5-1.9,0-1.3,0-2.7,0-4.1,0-.8,0-.8-.8-.8-2.4,0-4.9,0-7.3,0s-6.6,0-9.9,0c-2.2,0-4,1.6-4,3.8,0,.1,0,.2,0,.4v4.4c0,2.4,0,4.9,0,7.5ZM6.8,39v-3c0-2.5,1-5,2.8-6.8,2.4-2.5,5.8-3.9,9.2-3.9,1.8,0,3.6,0,5.5-.1,3-.2,5.7-1.6,7.6-3.9,1.4-1.7,2.2-3.9,2.1-6.2,0-.3-.1-.4-.4-.4-.5,0-1,0-1.5,0-.5,0-1.1.2-1.3.7-2,3.3-5.5,5.4-9.3,5.5-1.4,0-2.8,0-4.2,0-3.4,0-6.7,1.2-9.3,3.4-2.6,2.1-4,5.3-3.9,8.6,0,2,.8,3.9,2.1,5.4.2.2.4.4.6.6h0ZM30.8,6.7s0,0,0,0c0,1.2,0,2.4,0,3.6,0,.4.3.6.8.6h3.4c0,0,.1,0,.2,0-1.5-1.5-2.9-2.9-4.3-4.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Testing_Server",
    "data-name": "Testing Server",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.8,35.4v1.5h-2.4v7.6h-1.8v-7.6h-2.4v-1.5h6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.9,36.8v2.3h3.1v1.4h-3.1v2.4h3.4v1.5h-5.3v-9.1h5.3v1.5h-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.3,44.2c-.5-.2-.9-.5-1.2-.9-.3-.4-.4-.9-.5-1.4h1.9c0,.4.2.7.4.9.2.2.6.3,1,.3s.8-.1,1-.3c.2-.2.4-.5.4-.8s0-.5-.2-.7-.4-.3-.6-.4c-.2,0-.6-.2-1-.3-.6-.2-1.1-.3-1.4-.5-.4-.2-.7-.4-.9-.8-.3-.3-.4-.8-.4-1.4s.1-1,.4-1.4.6-.7,1.1-.9c.5-.2,1-.3,1.7-.3.9,0,1.7.2,2.3.7s.9,1.1,1,1.9h-2c0-.3-.1-.6-.4-.8-.2-.2-.6-.3-1-.3s-.6,0-.9.3c-.2.2-.3.4-.3.8s0,.4.2.6c.2.2.4.3.6.4s.6.2,1,.3c.6.2,1.1.3,1.4.5.4.2.7.4,1,.8s.4.8.4,1.4-.1.9-.4,1.4-.6.7-1.1,1-1.1.4-1.7.4-1.2-.1-1.7-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.8,35.4v1.5h-2.4v7.6h-1.8v-7.6h-2.4v-1.5h6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.8,35.4v9.1h-1.8v-9.1h1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.3,44.5h-1.8l-4.1-6.2v6.2h-1.8v-9.1h1.8l4.1,6.2v-6.2h1.8v9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.2,38.1c-.2-.4-.5-.7-.9-.9s-.8-.3-1.3-.3-1,.1-1.4.4c-.4.2-.7.6-1,1-.2.5-.4,1-.4,1.6s.1,1.1.4,1.6.6.8,1,1c.4.2.9.4,1.5.4s1.3-.2,1.7-.6c.4-.4.7-.9.9-1.5h-3.1v-1.4h4.9v1.6c-.1.6-.4,1.2-.8,1.8s-.9,1-1.5,1.3c-.6.3-1.3.5-2.1.5s-1.7-.2-2.4-.6c-.7-.4-1.3-.9-1.7-1.6-.4-.7-.6-1.5-.6-2.4s.2-1.7.6-2.4c.4-.7,1-1.3,1.7-1.7.7-.4,1.5-.6,2.4-.6s1.9.2,2.7.7,1.3,1.2,1.6,2.1h-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.2,44.2c-.5-.2-.9-.5-1.2-.9s-.4-.9-.5-1.4h1.9c0,.4.2.7.4.9.2.2.6.3,1,.3s.8-.1,1-.3c.2-.2.4-.5.4-.8s0-.5-.2-.7c-.2-.2-.4-.3-.6-.4-.2,0-.6-.2-1-.3-.6-.2-1.1-.3-1.4-.5-.4-.2-.7-.4-.9-.8-.3-.3-.4-.8-.4-1.4s.1-1,.4-1.4.6-.7,1.1-.9c.5-.2,1-.3,1.7-.3.9,0,1.7.2,2.3.7.6.5.9,1.1,1,1.9h-2c0-.3-.1-.6-.4-.8-.2-.2-.6-.3-1-.3s-.6,0-.9.3c-.2.2-.3.4-.3.8s0,.4.2.6.4.3.6.4.6.2,1,.3c.6.2,1.1.3,1.4.5.4.2.7.4,1,.8s.4.8.4,1.4-.1.9-.4,1.4c-.3.4-.6.7-1.1,1s-1.1.4-1.7.4-1.2-.1-1.7-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.4,36.8v2.3h3.1v1.4h-3.1v2.4h3.4v1.5h-5.3v-9.1h5.3v1.5h-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167,44.5l-2-3.5h-.9v3.5h-1.8v-9.1h3.4c.7,0,1.3.1,1.8.4.5.2.9.6,1.1,1,.2.4.4.9.4,1.4s-.2,1.1-.5,1.6c-.3.5-.9.8-1.5,1l2.2,3.7h-2.1ZM164.1,39.6h1.5c.5,0,.9-.1,1.1-.4s.4-.6.4-1-.1-.7-.4-1-.6-.3-1.1-.3h-1.5v2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.7,35.4l-3.3,9.1h-2.2l-3.3-9.1h2l2.5,7.2,2.5-7.2h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.5,36.8v2.3h3.1v1.4h-3.1v2.4h3.4v1.5h-5.3v-9.1h5.3v1.5h-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.1,44.5l-2-3.5h-.9v3.5h-1.8v-9.1h3.4c.7,0,1.3.1,1.8.4s.9.6,1.1,1c.2.4.4.9.4,1.4s-.2,1.1-.5,1.6c-.3.5-.9.8-1.5,1l2.2,3.7h-2.1ZM200.3,39.6h1.5c.5,0,.9-.1,1.1-.4.2-.2.4-.6.4-1s-.1-.7-.4-1c-.2-.2-.6-.3-1.1-.3h-1.5v2.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTestEnv);
export default __webpack_public_path__ + "static/media/logo-test-env.1fbce3279197912b0bf882e96fa403ef.svg";
export { ForwardRef as ReactComponent };